import React from 'react'
import styled from '@emotion/styled'
import { mq } from '../../helpers'
import { ServiceTypeBar } from './service-type-bar'
import { Text } from '../../styles/Components'
import MarketSelector from '../MarketSelector'
import { gsColors } from '../../styles/Variables'

const MarketServiceSelectorWrapper = styled.div`
  position: sticky;
  top: 60px;
  display: flex;
  border-bottom: 1px solid ${gsColors.lightTangerine};
  background-color: #FFF;
  z-index: 1;
  width: 100%;
  max-width: 1600px;
  justify-content: center;
  padding: 32px 88px;

  ${mq('max', '1280px')} {
    padding: 32px 44px;
  }

  ${mq('max', '1024px')} {
    padding: 32px 22px;
  }

  ${mq('max', '960px')} {
    padding: 32px 16px;
  }
  
  ${mq('max', '768px')} {
    padding: 20px 16px 0 16px;
  }

  div {
    .market-selector-container, .market-list-container {
      min-width: 400px;
      width: 400px;

      ${mq('max', '1280px')} {
        min-width: 300px;
        width: 300px;
      }

      ${mq('max', '1024px')} {
        min-width: 250px;
        width: 250px;
      }

      ${mq('max', '768px')} {
        width: 100%;
        min-width: 100%;
      }
    }
  }


  
  .inner {
    max-width: 1600px;
    width: 100%;
    display: flex;
    flex-direction: row;
    justify-content: space-between;

    ${mq('max', '768px')} {
      flex-direction: column;
    }

    .market-selector-wrapper {
      display: flex;
      align-items: center;
      justify-content: flex-start;
      width: 100%;
      max-width: 50%;

      ${mq('max', '768px')} {
        width: 100%;
        max-width: initial;
        flex-direction: column;
        align-items: flex-start;
      }
    }
  }
`

const MarketServiceSelector = ({
  markets,
  selectedMarket,
  setSelectedMarket,
  services,
  selectedTab,
  marketPrompt = 'Services in: ',
  hideTabs = false
}) => {
  return (
    <MarketServiceSelectorWrapper>
      <div className='inner'>
        <div className='market-selector-wrapper'>
          <Text 
            color={gsColors.meredithGrey} 
            variant='medium'
            margin='0 8px 0 0'
          >
            {marketPrompt}
          </Text>
          <MarketSelector
            markets={markets} 
            selected={selectedMarket}
            setSelected={setSelectedMarket}
          />
        </div>
        {!hideTabs && (
          <ServiceTypeBar 
            services={services} 
            selectedTab={selectedTab} 
          />
        )} 
      </div>
    </MarketServiceSelectorWrapper>
  )
}

export default MarketServiceSelector
